import { render } from "./pay_now_form.vue?vue&type=template&id=b94ec90e"
import script from "./pay_now_form.vue?vue&type=script&lang=js"
export * from "./pay_now_form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__